import { createSlice } from "@reduxjs/toolkit";
import { getCuisineDetailsAPI } from "../../api/cuisine";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
}; 

const getCuisineDetailsSlice = createSlice({
  name: "getCuisineDetails",
  initialState: data,
  reducers: {
   getCuisineDetailsSlice(state) {
      state.isLoading = true;
    },
   getCuisineDetailsSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    getCuisineDetailsSliceFailure(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
   getCuisineDetailsSliceReset(state) {
      state.isLoading = false;
      state.data = null;
    },
  },
});
export const getCuisineDetailsHandler = (id:any) => async (dispatch: any) => {
  try {
    dispatch(getCuisineDetailsAction.getCuisineDetailsSlice());
    const response: any = await getCuisineDetailsAPI(id);
    
    dispatch(getCuisineDetailsAction.getCuisineDetailsSliceSuccess(response));
  } catch (e: any) {
    dispatch(getCuisineDetailsAction.getCuisineDetailsSliceFailure(e?.response?.data));
  }
};
export default getCuisineDetailsSlice.reducer;
export const getCuisineDetailsAction = getCuisineDetailsSlice.actions;
